<script setup lang="ts">

</script>

<template>
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-12 overflow-hidden">
      <router-view></router-view>
    </div>
  </div>
</template>

<style scoped>

</style>